var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"bg-transparent"},[_c('v-layout',{staticClass:"bg-gray-custom",attrs:{"column":""}},[_c('nuxt'),_vm._v(" "),_c('MainBranding',{attrs:{"is-show-try-eown":false,"theme":"light"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }